import { allValues, Rights } from '../rights';

export const NURSING_ASSISTANT_UNTRAINED_RIGHTS = Object.freeze([
  Rights.RESIDENTS.READ.key,
  Rights.RESIDENTS.GENERAL.READ.key,
  Rights.RESIDENTS.CONTRACT.READ.key,
  Rights.RESIDENTS.CONTACTS.READ.key,
  Rights.RESIDENTS.CONSULTATION.READ.key,
  Rights.RESIDENTS.UTILS.READ.key,
  Rights.RESIDENTS.PASTORAL_CARE.READ.key,
  Rights.RESIDENTS.DOCUMENT_MANAGEMENT.READ.key,
  Rights.RESIDENTS.FILES.READ.key,
  Rights.BASE_DATA.DOCTORS.READ.key,
  Rights.BASE_DATA.SUPERVISOR.READ.key,
  Rights.CARE.READ.key,
  Rights.CARE.WRITE.key,
  Rights.LISTS.READ.key,
  Rights.LISTS.WRITE.key,
  Rights.LISTS.MEDICATION.key,
  Rights.LISTS.VISIT_SHEET_QUESTIONS.key,
  Rights.LISTS.NURSING_OVERVIEW.key,
  Rights.LISTS.HOSPITAL.key,
  Rights.LISTS.RISK_GROUPS.key,
  Rights.LISTS.BASE_DATA_GENERAL.key,
  Rights.LISTS.BASE_DATA_REFERENCE_CARE.key,
  Rights.LISTS.BASE_DATA_KV.key,
  Rights.LISTS.BASE_DATA_CONSULTING.key,
  Rights.LISTS.EXTERNAL_INFORMATION.key,
  ...allValues(Rights.CARE.TASKS),
  ...allValues(Rights.CARE.EXECUTION),
  Rights.CARE.ASSESSMENT.READ.key,
  Rights.CARE.CONSULTATION_FORM.READ.key,
  Rights.CARE.MOVEMENT_STATUS.READ.key,
  ...allValues(Rights.CARE.BIOGRAPHY),
  Rights.CARE.DATA_COLLECTION.READ.key,
  Rights.CARE.DECUBITUS_RISK.READ.key,
  ...allValues(Rights.CARE.NUTRITION_PROTOCOL),
  ...allValues(Rights.CARE.CASE_DISCUSSION),
  Rights.CARE.INDICATORS.READ.key,
  Rights.CARE.MEDICATION.READ.key,
  ...allValues(Rights.CARE.NURSING_REPORT),
  Rights.CARE.REPORT.READ.key,
  Rights.CARE.CARE_PLAN.READ.key,
  Rights.CARE.NURSE_VISIT.READ.key,
  Rights.CARE.CARE_ROUNDS.READ.key,
  Rights.CARE.PAIN_PROTOCOL.READ.key,
  ...allValues(Rights.CARE.SOCIAL_CARE),
  Rights.CARE.SOCIAL_CARE_GROUP.key,
  ...allValues(Rights.CARE.FALL_PROTOCOL),
  Rights.CARE.FALL_RISK.READ.key,
  Rights.CARE.VITAL_INFORMATIONS.READ.key,
  ...allValues(Rights.CARE.VITAL_SIGNS),
  Rights.CARE.DOCTORS_DIAGNOSIS.READ.key,
  Rights.CARE.VISIT_SHEET.READ.key,
  Rights.CARE.WOUND_DOCUMENTATION.READ.key,
  Rights.GENERAL.CALENDAR.READ.key,
  Rights.GENERAL.CALENDAR.WRITE.key,
  ...allValues(Rights.GENERAL.CONTACTS),
  ...allValues(Rights.GENERAL.MESSAGES),
  Rights.ROSTER.ACCESS.LIMITED_READ.key,
  Rights.ROSTER.WEEK_PLAN.key,
  Rights.ROSTER.VACATION_SCHEDULE.READ.key,
  Rights.CARE.GENERAL_ORDER.WRITE.key,
]);
